import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import EventPage from './EventPage';

const FallbackPage = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://beat.technovasolusi.id/';
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 p-8">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 text-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Redirecting...</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          This activity type is not available. You will be redirected to our main website.
        </p>
        <BeatLoader
          color="#ff6b6b"
          loading={true}
          size={20}
          aria-label="Loading Spinner"
        />
      </div>
    </div>
  );
};

const ActivityPage = () => {
  const { activityType, id } = useParams();

  const fallbackPage = <FallbackPage />

  if (activityType === 'event') {
    return <EventPage activityType={activityType} id={id} />
  }

  return fallbackPage;
};

export default ActivityPage; 